import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { InsuredPersonDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailCard } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailCard";
import { InsuredRiskDetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/InsuredRiskDetailRow";
import { getInsuredPersonName } from "web_myplann/Portfolio/Helpers/insuredPersonLabels";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	person: InsuredPersonDTO | undefined;
	currencySign: string;
	onClose: () => void;
};

export const InsuredPersonDetailDrawer: FC<Props> = ({
	open,
	person,
	currencySign,
	onClose,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			grabber
			title={person ? getInsuredPersonName(person) : undefined}
		>
			<Stack pb={theme.spacingTokens.lg}>
				{person?.identificationNumber && (
					<Typography
						variant="caption"
						color="text.secondary"
						px={theme.spacingTokens.lg}
					>
						{person.identificationNumber}
					</Typography>
				)}
				{person && person.risks.length > 0 && (
					<DetailCard
						label={t(
							Resources.Portfolio.AddLifeInsurance.InsuredPersons.risksTitle,
						)}
					>
						{person.risks.map((risk) => (
							<InsuredRiskDetailRow
								key={risk.id}
								risk={risk}
								currencySign={currencySign}
							/>
						))}
					</DetailCard>
				)}
			</Stack>
		</MyPlannDrawer>
	);
};
